// extracted by mini-css-extract-plugin
export default {"enrichment_whois_information":"enrichment-whois-information_enrichment_whois_information__u+zzc","block":"enrichment-whois-information_block__3tOiZ"};